import React from 'react';
import { NavbarColumns } from '../navbar-columns/navbar-columns';
import { NavbarFooter } from '../navbar-footer/navbar-footer';
import {
  NavContentContainer,
  NavDropdown,
  NavFullWidthContainer,
} from './navbar-dropdown.styles';

export const NavbarDropdown = ({
  columnData,
  footerData,
  handleReset,
  translate = true,
}) => {
  return (
    <NavFullWidthContainer>
      <NavDropdown>
        <NavContentContainer
          numberOfColumns={columnData.length}
          data-testid="nav-content-container"
        >
          <NavbarColumns data={columnData} handleReset={handleReset} />
        </NavContentContainer>
        <NavbarFooter footerLinks={footerData} translate={translate} />
      </NavDropdown>
    </NavFullWidthContainer>
  );
};
